import React from 'react'
import Typography from '@material-ui/core/Typography'

import withErrorNavigation from './withErrorNavigationHOC'
import {ADMIN_EMAIL} from '../../constants'
import theme from '../../theme'

const styles = {
  link: {color: theme.links.error.color},
  notice: {
    fontSize: '1.75rem',
    fontWeight: 'lighter'
  }
}

export const ErrorNotice401 = withErrorNavigation({href: '/login'})(() => (
  <div>
    <Typography variant="subheading" style={styles.notice}>
      You are unable to view this page, try&nbsp;
      <a href="/login" style={styles.link}>logging in</a>
      &nbsp;or&nbsp;
      <a
        href={`mailto:${ADMIN_EMAIL}?subject=Decision Counseling Program Notice`}
        style={styles.link}
      >
        report this problem
      </a>.
    </Typography>
  </div>
))

export const ErrorNotice404 = withErrorNavigation({href: '/'})(() => (
  <div>
    <Typography variant="display1" style={{marginBottom: 25}}>Page Not Found</Typography>
    <Typography variant="subheading">
      The page you're looking for doesn't exist.
    </Typography>
  </div>
))

export const ErrorNotice500 = withErrorNavigation({withBackButton: true})(() => (
  <div>
    <Typography variant="subheading" style={styles.notice}>
      Sorry, something went wrong. Please try again or &nbsp;
      <a
        href={`mailto:${ADMIN_EMAIL}?subject=Decision Counseling Program Notice`}
        style={styles.link}
      >
        report this problem
      </a>.
    </Typography>
  </div>
))


// WEBPACK FOOTER //
// ./src/components/error-notices/notices.js